<script setup lang="ts">
import { useRouter } from 'vue-router';
import Button from 'primevue/button';
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';

import { ACTION_TOAST_GROUP, type ActionToastMessage } from './action-toast';

defineOptions({ name: 'UiActionToast' });

const router = useRouter();
const toast = useToast();

const handleAction = (message: ActionToastMessage) => {
  toast.remove(message);
  void router.push(message.actionTo);
};
</script>

<template>
  <Toast :group="ACTION_TOAST_GROUP" class="ui-action-toast">
    <template #message="{ message }: { message: ActionToastMessage }">
      <div class="ui-action-toast__content" data-testid="ui-action-toast">
        <p class="ui-action-toast__summary">{{ message.summary }}</p>
        <p v-if="message.detail" class="ui-action-toast__detail">{{ message.detail }}</p>
        <Button
          :label="message.actionLabel"
          severity="secondary"
          variant="text"
          rounded
          size="small"
          class="ui-action-toast__action"
          data-testid="ui-action-toast-action"
          @click="handleAction(message)"
        />
      </div>
    </template>
  </Toast>
</template>

<style scoped lang="scss">
.ui-action-toast__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: $static-space-1;
  width: 100%;
}

.ui-action-toast__summary {
  margin: 0;
  font-size: $text-md;
  font-weight: $font-medium;
  line-height: $leading-tight;
}

.ui-action-toast__detail {
  margin: 0;
  font-size: $text-sm;
  font-weight: $font-regular;
  line-height: $leading-tight;
}

.ui-action-toast__action {
  margin-left: -$static-space-2;
  font-weight: $font-medium;
}
</style>
